import { ShieldCheck } from "lucide-react";
import {
  ContainmentCardsParamsSchema,
  defaultContainmentCardsParams,
  type ContainmentCardsParams,
} from "@playbookai/widget-schemas";
import type { WidgetDef } from "../types.js";
import { registerWidget } from "../registry.js";
import { ContainmentCardsWidget } from "./Component.js";

export const containmentCardsDef: WidgetDef<ContainmentCardsParams> = {
  kind: "containmentCards",
  label: "Containment Cards",
  modes: ["canvas"],
  singleton: false,
  defaultSize: { w: 352, h: 300 },
  defaultParams: defaultContainmentCardsParams,
  Component: ContainmentCardsWidget,
  storage: "sql",
  schema: ContainmentCardsParamsSchema,
  accent: "amber",
  icon: ShieldCheck,
  subtitle: "Hold the line while root cause is found",
  defaultRoster: false,
  category: "multi",
  layout: { col: 1, row: 3, width: 352, height: 300 },
  renderFooter: (data) => {
    const done = data.actions.filter((a) => a.status === "Done").length;
    return {
      left: `${done} of ${data.actions.length} complete`,
      right: "Click to focus PlayerAI on containment",
    };
  },
};

registerWidget(containmentCardsDef);
